module.exports = __webpack_public_path__ + "static/img/fail.93723615.png";